export const SequencesFile = window.sequences.SequencesFile
export const ElementColumns = window.sequences.utils.ElementColumns
export default window.sequences.SequencesManager.instance